//import firebase from 'firebase/compat/app/dist/index.mjs';
import firebase from "firebase/compat/app";

// Initialize Firebase
let firebaseConfig = {
    projectId: "dune-recovery",
    apiKey: "AIzaSyAZ87QzqZaqVWqrOy0uRUymu8VZ2vx05SU",
    authDomain: "glamis911.com",
    storageBucket: "dune-recovery.appspot.com",
    messagingSenderId: "287951343419",
    appId: "1:287951343419:web:d5ab6e70757f4f8f70b11e",
    measurementId: "G-SLELSNRXZ0"
};

let initializedApps = firebase.apps;

console.log("Initializing App V8");

initializedApps.forEach(app => {
    console.log(`App v8 ${app.name}: { ${app.options.projectId}, ${app.options.authDomain} }`)
});

export let app = !initializedApps.length ? firebase.initializeApp(firebaseConfig) : initializedApps[0];
